import { useEffect } from "react";
import { useSelector } from "react-redux";
import { NO_COLOR_PREFERENCE } from "src/common";
import { useThemePreferenceSync } from "src/common/hooks/themePreference";

const ThemeSync = () => {
  const colors = useSelector((state: any) => state?.application?.colors);
  const lightMode = colors?.lightMode;
  const { applyThemePreference } = useThemePreferenceSync(colors);

  useEffect(() => {
    if (lightMode == null || !sessionStorage.getItem(NO_COLOR_PREFERENCE)) {
      return;
    }

    applyThemePreference(Boolean(lightMode));
    sessionStorage.removeItem(NO_COLOR_PREFERENCE);
  }, [lightMode, applyThemePreference]);

  return null;
};

export default ThemeSync;
